/***
 *
 *   SEARCH
 *   Search input field
 *
 *   PROPS
 *   throttle: throttle the callback execution in ms
 *   callback: function executed on change and submit
 *
 **********/

import { Button } from "components/lib";
import { useEffect, useState } from "react";

import Style from "./search.module.scss";

export function Search(props) {
  const [value, setValue] = useState(props.value || "");
  const [typing, setTyping] = useState(false);

  useEffect(() => {
    const onKeyPress = () => {
      setTyping(true);

      setTimeout(() => {
        setTyping(false);
      }, 1000);
    };

    window.addEventListener("keydown", onKeyPress);
    return () => window.removeEventListener("keydown", onKeyPress);
  }, []);

  const search = async () => {
    if (typing) return;
    props.callback(value);
  };

  useEffect(() => {
    if (!typing && value !== "") search();
  }, [value]);

  return (
    <form className={Style.bar}>
      <input
        type="text"
        className={Style.input}
        placeholder={props.placeholder || "Search"}
        value={value}
        onChange={(e) => {
          setValue(e.target.value);
          !props.throttle && props.callback(e.target.value);
        }}
      />

      <Button
        icon="search"
        className={Style.button}
        iconSize={20}
        position="absolute"
        action={() => props.callback(value)}
      />
    </form>
  );
}
